import { HumanContext } from "../context/HumanContext";
import { useContext } from "react";

export const useHumanContext = () => {
    const context = useContext(HumanContext);

    if (!context) {
        return Error('useHumanContext must be used inside an HumanContextProvider');
    };

    return context;
};